
<template>
  <div>

    <div class="card">
      <div class="card-body">
        <!-- FILTROS -->
        <div class="row">
          <div class="col-sm-3 text-left">
            <div class="form-group pt-3">
              <input
                :disabled="loading"
                style="width:300px;"
                v-model="filter"
                type="text"
                class="form-control"
                placeholder="Buscar por nombre"
              />
            </div>
          </div>
          <div class="col-sm-4 pt-3" style="display:flex;">
            <select :disabled="loading || loadingCategories" v-model="filterCategory" class="form-control mr-1">
              <option value="">
                <span v-if="loadingCategories">Cargando categorias..</span>
                <span v-else>-Seleccione categria-</span>
              </option>
              <option
                v-for="pCategory in categories"
                :value="pCategory.id"
                :key="pCategory.id"
              >{{ pCategory.name }}</option>
            </select>
            <button :disabled="loading" @click="getProducts" class="btn main-bg mt-0 search-btn"><i class="fa fa-search"></i></button>
          </div>
          <div class="col-sm-5 text-right">
            <button v-if="$userIsAdmin() || $store.getters.getRole === $constants.userRoles.COMERCE" :disabled="loading" @click="openImportProductsModal" class="btn btn-light text-dark mr-1">
              <i class="fa fa-upload"></i> 
              Cargar productos
            </button>
            <button v-if="$userIsAdmin() || $store.getters.getRole === $constants.userRoles.COMERCE" :disabled="loading" @click="openModal" class="btn main-bg">
              <i class="fa fa-plus"></i>
              Crear Producto
            </button>
          </div>
        </div>
        <!-- *********** -->

        <!-- LISTA DE PRODUCTOS -->
        <div style="overflow-y:auto;max-height:50vh;">
          <table class="table" id="list">
            <thead class="thead-light">
              <tr style="text-transform: none !important;">
                <th>Nombre</th>
                <th class="text-center">Precio</th>
                <th class="text-center">Stock</th>
                <th>Categoría</th>
                <th class="text-center">Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="p in products"
                v-bind:key="p.id"
                :class="p.deleted ? 'bg-danger' : ''"
              >
                <td>
                  <div style="height:50px;width:50px;display:inline;">
                    <img :src="p.photo || '/logo_blue.png'" alt="Foto producto" style="width:inherit;height:inherit;" />
                  </div>&nbsp;
                  <span>{{ p.name }}</span>
                </td>
                <td class="text-center">{{ p.price | money }}</td>
                <td class="text-center" :class="p.stock < 10 ? 'text-danger bold' : ''">
                  {{ p.stock | number }}
                </td>
                <td>{{ p.categoryName }}</td>
                <td class="text-center">
                  <a @click.prevent="editProduct(p)" href="#" title="Editar">
                    <i class="fa fa-edit fa-2x"></i>&nbsp;
                  </a>&nbsp;
                  <a
                    v-if="$userIsAdmin()" 
                    title="Eliminar producto"
                    @click="deleteProduct(p)"
                    href="#"
                    class="text-danger"
                  >
                    <i class="fa fa-trash fa-2x"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Loader -->
          <div v-show="loading ">
            <div class="text-center" colspan="5">
              <Loader />
            </div>
          </div>
        </div>      
        <!-- ************ -->

        <div class="mt-3 border-top pt-2">
          <b style="font-weight:bold">{{ products.length }}</b> productos
        </div>
 
      </div>
    </div>

    <!-- MODAL PRODUCTOS-->
    <div class="modal fade" id="product-modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Detalles del producto
              <small v-if="editing" class="text-warning">(Editando)</small>
            </h5>
            <button type="button" class="close" @click="closeProductModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
        
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="home-tab"
                  data-toggle="tab"
                  href="#tab-product-info"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                >Informacion principal</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="profile-tab"
                  data-toggle="tab"
                  href="#tab-product-photo"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                >Fotos</a>
              </li>
            </ul>
            <form class="mt-2">
              <div class="tab-content" id="myTabContent">
                <div
                  class="tab-pane fade show active"
                  id="tab-product-info"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <div class="row">
                    <div class="col-sm-6">
                      <!-- NOMBRE -->
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>Nombre</label>
                          <input
                            type="text"
                            v-model="product.name"
                            class="form-control"
                            :maxlength="maxProductNameLength"
                          />
                        </div>
                      </div>

                      <!-- CATEGORIA -->
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="exampleInputEmail1">Categoria</label>
                          <select v-model="product.categoryId" class="form-control">
                            <option
                              v-for="pCategory in categories"
                              :value="pCategory.id"
                              :key="pCategory.id"
                            >{{ pCategory.name }}</option>
                          </select>
                        </div>
                      </div>

                      <!-- DESCRIPCION -->
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>Descripcion</label>
                          <textarea
                            rows="10"
                            v-model="product.description"
                            class="form-control textarea"
                            :maxlength="maxProductDescriptionLength"
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <!-- PRECIO-->
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-sm-5">
                            <div class="form-group">
                              <label for="exampleInputEmail1">Precio</label>
                              <div class="input-group mb-3">
                                <div class="input-group-prepend currency-badge">
                                  <span
                                    class="input-group-text"
                                    style="padding-right: 4px;"
                                  >RD$</span>
                                </div>
                                <input
                                  type="number"
                                  v-model="product.originalPrice"
                                  maxlength="6"
                                  min="1"
                                  max="9999"
                                  class="form-control"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-5">
                            <div class="form-group">
                              <label for="convertionRate">Tasa</label>
                              <div class="input-group mb-3">
                                <div class="input-group-prepend currency-badge">
                                  <span
                                    class="input-group-text"
                                    style="padding-right: 4px;"
                                  >RD$</span>
                                </div>
                                <input
                                  type="number"
                                  v-model="product.convertionRate"
                                  maxlength="6"
                                  min="1"
                                  max="9999"
                                  id="convertionRate"
                                  class="form-control"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-2">
                            <div class="form-group">
                              <label for="finalPrice">$USD</label>
                              <div class="bold">{{ priceInUSD }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- STOCK -->
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="p-stock">Stock</label>                          
                          <input
                            type="number"
                            id="p-stock"
                            v-model="product.stock"
                            min="0"
                            max="9999"
                            maxlength="6"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <!-- DISPONIBLE -->
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="exampleInputEmail1">Disponible</label>
                          <br />
                          <label class="switch">
                            <input type="checkbox" v-model="product.available" />
                            <span class="slider"></span>
                          </label>
                        </div>                        
                      </div>

                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="tab-product-photo"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <div class="row">
                    <div class="col-sm-12">
                      <ImageSelectBtn label="Agregar nueva foto" id="PRODUCT" v-on:file-selected="setProductFile" />

                      <div class="imgs-container">
                        <div class="product-img-container mr-2" v-for="x in productPhotos" :key="x.id">
                          <img class="img-thumbnail img-responsive product-img" :src="x.photo" alt="Foto"/>
                          <a @click="dropProductImg(x)" title="Eliminar" href="#" class="drop-product-img">
                            <span class="fa fa-times-circle text-danger"></span>
                          </a>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
            </form>
           
          </div>
          <div class="modal-footer">
            <div class="row" style="width: 100%;">
              <div class="col-sm-3">
                <div id="product-category-loading" v-show="loaders.product">
                  <Loader />
                </div>
              </div>
              <div class="col-sm-9 text-right">
                <button
                  type="button"
                  :disabled="loaders.product"
                  class="btn btn-danger mr-2"
                  @click="closeProductModal()"
                >
                  <i class="fa fa-close"></i>
                  Cancelar
                </button>
                <button
                  v-if="$userIsAdmin() || $store.getters.getRole === $constants.userRoles.COMERCE" 
                  type="button"
                  :disabled="loaders.product"
                  class="btn main-green-bg"
                  @click="saveProduct()"
                >
                  <i class="fa fa-save"></i>
                  Guardar cambios
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- =========================== -->

    <!-- MODAL IMPORTAR PRODUCTOS -->
    <div class="modal fade" id="import-products-modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg big-modal" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Cargar productos desde archivo</h5>
            <button type="button" class="close" @click="closeImportModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <div class="row">
              <div class="col-sm-12">
                <h6>Orden de los campos</h6>
                <ul id="positions-sortable">
                  <li 
                    v-for="(field, index) in fields" 
                    :data-field_name="field.name"
                    :data-field_id="field.id"
                    :key="index" 
                    class="list-group-item ui-state-default pointer">
                    {{ field.name }}
                  </li>
                </ul>                
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-sm-6">
                <button :disable="loaders.importProducts" @click="chooseFile" class="btn btn-primary">
                  <span v-if="!loaders.importproducts">Seleccione archivo</span>
                  <span v-else>Procesando...</span>
                </button>
                <input @change="handleImportFile" type="file" hidden id="import-file">
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="tasa">Tasa de conversión</label>
                  <input 
                    type="number" 
                    min="1" 
                    max="100" 
                    v-model="currencyConversion" 
                    class="form-control" 
                    id="tasa" 
                    :disabled="loaders.importProducts || previewProducts.length === 0">
                  <small>(El precio se dividira entre este valor)</small>
                </div>
              </div>
            </div>
            <h5 v-if="previewProducts.length">Productos seleccionados: {{ selectedPreviewProducts | number }}</h5>
            <div style="overflow-y:auto; max-height:40vh;">
              <table class="table table-condensed" v-show="previewProducts.length ">
                <thead class="thead-light">
                  <tr>
                    <th>Sel.</th>
                    <th>CÓDIGO</th>
                    <th>Categortia</th>
                    <th>Marca</th>
                    <th>Nombre</th>
                    <th>Precio</th>
                    <th>Imagen</th>
                    <th>Stock</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(p, index) in previewProducts" @click="setSelected(p)" :class="p.selected ? 'bg-success' : ''" :key="index">
                    <td><input type="checkbox" v-model="p.selected" :id="'chk_'+p.id"></td>
                    <td>{{ p.id }}</td>
                    <td>{{ p.category }}<br>{{ p.categoryId }}</td>
                    <td>{{ p.brand }}</td>
                    <td>{{ p.name }}</td>
                    <td>{{ p.price | money }}</td>
                    <td><img :src="p.photo" class="preview-photo" :alt="`Foto `+p.name"></td>
                    <td>{{ p.stock }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
          <div class="modal-footer">
            <div class="row" style="width: 100%;">
              <div class="col-sm-6 text-left">
                <div v-show="loaders.importProducts" style="align-items: center;display: flex;">
                  <Loader />
                  <span style="margin-left: 5px;">{{ importProcessCurrentLabel }}</span>
                </div>
              </div>
              <div class="col-sm-6 text-right">
                <button :disabled="loaders.importProducts" type="button" class="btn btn-danger mr-1" @click="closeImportModal">
                  <i class="fa fa-close"></i>
                  Cancelar
                </button>
                <button
                  :disabled="loaders.importProducts || previewProducts.length === 0"
                  type="button"
                  class="btn btn-primary"
                  @click.prevent="startProductsImport"
                >
                  <i class="fa fa-check"></i>
                  Cargar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- =========================== -->

  </div>
</template>

<script>
import firebase from "firebase/app";
import ImageSelectBtn from "./ImageSelectBtn";
import readXlsxFile from 'read-excel-file';
import Loader from './Loader'
import { CompanyService } from '../../services/CompanyService';

export default {
  name: "Products",
  props: ["company"],
  components: {ImageSelectBtn, Loader},
  data: function () {
    return {
      storage: firebase.storage().ref("Company"),
      modalOptions: {
        keyboard: false,
        backdrop: false,
      },
      product: {
        id: "",
        name: "",
        description: "",
        price: "",//en USD
        originalPrice: "",//en RD
        categoryId: "",
        photo: "",
        photoRef: "",
        photoPreview: "",
        stock: 0,
        available: false,
        convertionRate: ''
      },
      products: [],
      loading: false,
      loaders: {
        category: false,
        product: false,
        importProducts: false
      },
      editing: false,
      maxProductNameLength: 40,
      maxProductDescriptionLength: 80,
      companyCurrency: "USD",
      noProducts: false,
      filter: "",
      cropper: null,
      cropPreview: "",
      fields: {
        0: {id: 'id', name: 'CÓDIGO'},
        1: {id: 'category', name: 'CATEGORIA'},
        2: {id: 'brand', name: 'MARCA'},
        3: {id: 'name', name: 'NOMBRE'},
        4: {id: 'price', name: 'PRECIO'},
        5: {id: 'photo', name: 'FOTO'},
        6: {id: 'stock', name: 'STOCK'},
      },
      previewProducts: [],
      currencyConversion: '',
      maxWrites: 500,
      anotherCategories: {},
      filterCategory: '',
      allCategories: [],
      categoriesToUpdate: [],
      loadingCategories: false,
      categories: [],
      importProcessCurrentLabel: '',
      companyService: new CompanyService(),
      productPhotos: [],
      productPhotoFiles: []
    };
  },
  methods: {
    dropProductImg(img){
      this.productPhotos.splice(
        this.productPhotos.findIndex(x => x.id === img.id),
        1
      );
    },
    getCategories: async function () {
      this.loadingCategories = true;
      this.categories = await this.companyService.getProductCategories(this.company);
      this.loadingCategories = false;
    },
    getProducts: async function () {
      if(this.filterCategory == '' && this.filter == ''){
        const ok = await this.$helpers.confirm('Si no expecificas un termino de busqueda o una categoria, se mostraran todos los productos');
        if(!ok){
          return;
        }
      }
      this.products = [];
      this.loading = true;
      try {
        const resp = await this.companyService.getCompanyProducts(
          this.company,
          false,
          this.filter,
          this.filterCategory,
        );
        resp.data.forEach(x => {
          x.categoryName = this.getCategoryName(x.category_id);
          x.selected = false;
        });
        this.products = resp.data;
      } catch (error) {
        console.log('err ',error);
      }
      this.loading = false;
    },
    //*********************** */
    // IMPORT PRODUCTS
    setSelected(x){
      x.selected = !x.selected;
    },
    async startProductsImport(){
      const products = this.previewProducts.filter(x => x.selected === true);
      if(products.length === 0){
        this.$helpers.message('Faltan campos', 'Debes seleccionar almenos 1 producto', 'warning');
        return;
      }
      if(this.currencyConversion === '' || this.currencyConversion === 0 || isNaN(String(this.currencyConversion).trim())){
        this.$helpers.message('Faltan campos', 'Debes especificar la tasa de conversión', 'warning');
        return;
      }
      const ok = await this.$helpers.confirm(`
        Estas apunto de cargar ${ this.$helpers.asNumber(products.length) } productos a la base de datos.
      `);
      if(ok){
        this.importProcessCurrentLabel = 'Cargando productos';

        this.loaders.importProducts = true;
        try {
          const res = await this.companyService.importProducts(
            this.company,
            products,
            this.currencyConversion,
            this.$store.getters.getUserId
          );
          if(res.ok){

            this.$helpers.message('Muy bien', 'Los productos de cargaron correctamente!', 'success');
            this.importProcessCurrentLabel = '';
            this.closeImportModal();
          }else{
            this.$helpers.message('Error', res.message, 'error');

          }
        } catch (error) {
          console.log(error);
          this.$helpers.message('Oops', error.message, 'error');
        }
        this.loaders.importProducts = false;
      }
    },
    async handleImportFile({target}){
      if(target.files[0]){
        const file = target.files[0];
        if(String(file.name).includes('.xlsx')){
          this.importProcessCurrentLabel = 'Formateando archivo de productos';

          this.loaders.importProducts = true;
          const productsArray = await readXlsxFile(file);
          productsArray.shift();
          this.previewProducts = productsArray.map(x => {
            const stock = Number(x[6] || 0);
            const selected = stock > 0 && String(x[1]) !== 'NaN';
            return {
              id: x[0],
              category: String(x[1]) !== 'NaN' ? x[1] : 'N/A',
              brand: x[2] || '',
              name: x[3],
              price: x[4] || 0,
              photo: x[5] || '',
              stock: stock,
              selected: selected,
              categoryId: '',
              categoryName: '',
            }
          });
                    
          this.loaders.importProducts = false;

        }else{
          this.$helpers.message('Archivo invalido', 'Solo se admite .xlsx', 'warning');
        }
      }
    },
    chooseFile(){
      $('#import-file').trigger('click');
    },
    async openImportProductsModal(){
      $('#import-products-modal').modal('show');
    },
    closeImportModal(){
      $('#import-file').val('');
      $('#import-products-modal').modal('hide');
      this.previewProducts = [];
      this.currencyConversion = '';
      this.tasa = '';
      this.importProcessCurrentLabel = '';
    },
    //=====================================
    setProductFile(data){
      const _id = Date.now();
      this.product.photo = data.file;
      this.productPhotoFiles.push({
        file: data.file,
        id: _id
      });
      this.productPhotos.push({
        photo: data.preview,
        id: _id,
      });
    },
    getCategoryName: function (id) {
      let name = "N/D";
      for (let i = 0; i < this.categories.length; i++) {
        if (this.categories[i].id == id) {
          name = this.categories[i].name;
          break;
        }
      }
      return name;
    },
    // SAVE PRODUCT <======================
    saveProduct: async function () {
      if (!this.validate()) return false;
      if (this.editing && this.product.id != "") {
        const ok = await this.$helpers.confirm("Confirme esta accion");
        if (!ok) {
          return;
        }
      }
      const _name = String(this.product.name).trim(); 
      this.loaders.product = true;
      try {
        let data = {
          name: _name,
          price: Number(this.priceInUSD),
          category_id: this.product.categoryId,
          description: this.product.description.trim(),
          tags: _name.toLowerCase().split(' '),
          available: !!this.product.available,
          stock: Number(this.product.stock),
          convertion_rate: Number(this.product.convertionRate),
          original_price: Number(this.product.originalPrice)
        };
        const response = await this.companyService.setProduct(
          this.company,
          this.product.id,
          data,
          this.product.photo,
          (uploadProgress) => {
            console.log('Subida ',uploadProgress);
          },
          this.$store.getters.getUserId
        );
        if(response.ok){
          //Update product in list
          for (let index = 0; index < this.products.length; index++) {
            if(this.products[index].id === this.product.id){
              this.products[index].name = data.name;
              this.products[index].category_id = data.category_id;
              this.products[index].description = data.description;
              this.products[index].price = data.price;
              this.products[index].original_price = data.original_price;
              this.products[index].convertion_rate = data.convertion_rate;
              this.products[index].stock = data.stock;
              this.products[index].available = data.available;
              break;
            }
          }
          this.cleanProductFields();
          $("#product-photo").val("");
          $("#product-modal").modal('hide');
          this.$helpers.toast("Producto guardado");
          this.loaders.product = false;

        }else{
          throw new Error(response.message);
        }

      } catch (e) {
        console.log(e);
        this.loaders.product = false;
        this.$helpers.toast("Error del servidor", "error");
      }
    },
    validate: function () {
      if (this.product.name.length < 2) {
        this.$helpers.toast("El nombre es muy corto.", "error");
        return false;
      }
      if (this.product.originalPrice.length === 0 || isNaN(this.product.originalPrice)) {
        this.$helpers.toast("El precio es invalido.", "error");
        return false;
      }
      if(this.product.convertionRate.length === 0 || isNaN(this.product.convertionRate)){
        this.$helpers.toast("La tasa de conversión es invalida.", "error");
        return false;
      }
      return true;
    },
    cleanProductFields: function () {
      this.product.name = "";
      this.product.price = "";
      this.product.id = "";
      this.product.description = "";
      this.product.photo = "";
      this.product.photoPreview = "";
      this.product.stock = "";
      this.product.convertionRate = '';
      this.productPhotos = [];
      this.productPhotoFiles = [];
    },
    openModal: function () {
      $("#product-modal").modal(this.modalOptions);
    },
    closeProductModal: function () {
      this.cleanProductFields();
      this.editing = false;
      $("#home-tab").trigger("click");
      $("#product-modal").modal("hide");
    },
    deleteProduct: function (product) {
      this.$helpers.confirm("El producto se eliminara").then(async (ok) => {
        if (ok) {
          const res = await this.companyService.deleteProduct(this.company, product.id, product.photoRef);
          if(res.ok){
            this.products = this.products.filter((p) => p.id !== product.id);
            this.$helpers.toast("Producto eliminado!");
          }else{
            this.$helpers.toast("Error", res.message, 'error');
          }
        }
      });
    },
    editProduct: async function (data) {
      
      this.editing = true;
      this.product.id = data.id;
      this.product.name = data.name;
      this.product.description = data.description || "";
      this.product.originalPrice = data.originalPrice;
      this.product.convertionRate = data.convertionRate;
      this.product.categoryId = data.categoryId;
      this.product.photo = "";
      this.product.stock = data.stock;
      this.product.available = data.available;
      this.product.photoPreview = data.photo != "" ? data.photo : "";
      $("#product-modal").modal(this.modalOptions);
  
      if(data.photo){
        this.productPhotos.push({
          photo: data.photo,
          id: 0
        });
      }
      const photosResponse = await this.companyService.getProductPhotos(this.company, data.id);

      if(photosResponse.ok){
        this.productPhotos.concat(photosResponse.photos);
      }
      
    },
  },
  beforeMount(){
    this.getCategories();
  },
  computed: {
    selectedPreviewProducts(){
      return this.previewProducts.filter(x => x.selected).length;
    },
    priceInUSD(){
      const convertion = Number(this.product.convertionRate || 0);
      const priceInRd = Number(this.product.originalPrice || 0);
      if(convertion && priceInRd){
        return Number(priceInRd / convertion).toFixed(2);
      }
      return 0;
    }
  },
  watch: {
    "product.price": function (value) {
      this.product.price = String(value).replace(/\[a-Z][A-Z]/gi, "");
    },
  },
  mounted: function(){
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.imgs-container{
  display: flex;
}
.product-img-container{
  position: relative;
  width: 110px;
  height: 110px;
}
.drop-product-img{
  position: absolute;
  top: -10px;
  right: -7px;
  font-size: x-large;
}
#positions-sortable { 
  list-style-type: none; 
  margin: 0; 
  padding: 0; 
}
#positions-sortable li { 
  /* margin: 3px 3px 3px 0;  */
  padding: 1px; 
  float: left; 
  min-width: 85px;
  max-width: 113px;
  height: 30px;  
  text-align: center; 
}
  
.twrap {
  max-height: 300px;
  overflow-y: auto;
}

.new-ingredient-name {
  margin-top: 10px;
}
table {
  font-size: 12px !important;
}
.modal-c {
  max-width: 402px !important;
}
.btn-close {
  background-color: crimson !important;
}
.currency-badge {
  border-right: solid 1px #ccc;
}
.p-description {
  word-break: break-all;
}
* {
  font-weight: 500;
}
.preview-photo{
  height: 70px;
}
.big-modal{
  max-width: 1100px !important;
}
.search-btn{
  max-height: 38px;
}
.product-img{
  max-height: 110px;
}
</style>
